import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillOldData = function backfillOldData(_this) {
  var otherlinkInfo = _.get(_this, "oppBusiData.oldBusiData.otherlinkInfo");
  if (!_.isEmpty(otherlinkInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlinkInfo[0]);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherlinkInfo = _.cloneDeep(_.get(_this.historyData, SAVE_PATH));
  var otherlinkInfo2 = _.cloneDeep(_.get(_this.historyData, SAVE_PATH2));

  if (!_.isEmpty(otherlinkInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlinkInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherlinkInfo);
  }
  if (!_.isEmpty(otherlinkInfo2)) {
    var otherlinkObj = otherlinkInfo2[0];

    otherlinkObj.OFFICE_TEL = otherlinkInfo.OFFICE_TEL || otherlinkObj.LINKMAN_TEL || "";

    otherlinkObj.LINKMAN_TEL = otherlinkInfo.MOBILE_TEL;

    otherlinkObj.EMAIL = otherlinkInfo.EMAIL || otherlinkObj.LINKMAN_EMAIL || "";

    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlinkObj);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherlinkObj);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.LINKMAN.VALID_TYPE = "length[4, 32]";
  fields.IS_SAME_AGENT.FIELD_TYPE = "radio";
  fields.IS_SAME_AGENT.DEFAULT_VALUE = "0";
  fields.EMAIL.VALID_TYPE = "email[48]";
  fields.LINKMAN_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.LINKMAN_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
  });
  _.set(fields, "LINKMAN.FIELD_TITLE", "联系人名称");
  _.set(fields, "FAX.FIELD_TYPE", "normalinput");
  _.set(fields, "FAX.VALID_TYPE", "tel");
  if (_this.userType == "2") {
    _.set(fields, "FAX.FIELD_REQUIRED", "1");
    _.set(fields, "EMAIL.FIELD_REQUIRED", "1");
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var contactInfo, linkManInfo, officeInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contactInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2 + "[0]"], true);
              linkManInfo = {
                LINKMAN: contactInfo.LINKMAN,
                LINKMAN_DATA_SOURCE: contactInfo.LINKMAN_DATA_SOURCE,

                LINKMAN_TEL: contactInfo.OFFICE_TEL,
                LINKMAN_TEL_DATA_SOURCE: contactInfo.OFFICE_TEL_DATA_SOURCE,

                LINKMAN_ID_TYPE: contactInfo.LINKMAN_ID_TYPE,
                LINKMAN_ID_TYPE_DATA_SOURCE: contactInfo.LINKMAN_ID_TYPE_DATA_SOURCE,

                LINKMAN_ID: contactInfo.LINKMAN_ID,
                LINKMAN_ID_DATA_SOURCE: contactInfo.LINKMAN_ID_DATA_SOURCE,

                LINKMAN_MOBILE_TEL: contactInfo.LINKMAN_TEL,
                LINKMAN_MOBILE_TEL_DATA_SOURCE: contactInfo.LINKMAN_TEL_DATA_SOURCE,

                LINKMAN_CORP_FAX: contactInfo.FAX,
                LINKMAN_CORP_FAX_DATA_SOURCE: contactInfo.FAX_DATA_SOURCE,

                LINKMAN_ZIP: _.get(params, "BIZ_DATA.CONTACT_INFO.ID_ZIP_CODE", ""),
                LINKMAN_ZIP_DATA_SOURCE: _.get(params, "BIZ_DATA.CONTACT_INFO.ID_ZIP_CODE_DATA_SOURCE", ""),

                LINKMAN_EMAIL: contactInfo.EMAIL,
                LINKMAN_EMAIL_DATA_SOURCE: contactInfo.EMAIL_DATA_SOURCE,

                LINKMAN_CORP_URL: "",
                LINKMAN_ADDR: _.get(params, "BIZ_DATA.CONTACT_INFO.CORP_ADDR", ""),
                LINKMAN_ADDR_DATA_SOURCE: _.get(params, "BIZ_DATA.CONTACT_INFO.CORP_ADDR_DATA_SOURCE", ""),

                LINKMAN_FLAG: "",
                LINKMAN_SEX: contactInfo.LINKMAN_SEX || _.get(contactInfo, ".AGENT_INFO.SEX"),
                LINKMAN_EXP_DATE: contactInfo.LINKMAN_EXP_DATE || _.get(contactInfo, ".AGENT_INFO.LINKMAN_EXP_DATE")
              };

              if (contactInfo.IS_SAME_AGENT == "1") {
                linkManInfo.LINKMAN_MOBILE_TEL = _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.MOBILE_TEL.DEFAULT_VALUE;
              }
              officeInfo = {
                LINKTEL_ORDER: "1",
                MOBILE_TEL: linkManInfo.LINKMAN_MOBILE_TEL,
                MOBILE_TEL_DATA_SOURCE: linkManInfo.LINKMAN_MOBILE_TEL_DATA_SOURCE,

                WELL_TEL: "",
                OFFICE_TEL: contactInfo.OFFICE_TEL,
                OFFICE_TEL_DATA_SOURCE: contactInfo.OFFICE_TEL_DATA_SOURCE,

                FAX: contactInfo.FAX,
                FAX_DATA_SOURCE: contactInfo.FAX_DATA_SOURCE,

                EMAIL_DATA_SOURCE: contactInfo.EMAIL_DATA_SOURCE,
                EMAIL: contactInfo.EMAIL,
                OFFICE_ADDR: _.get(params, "BIZ_DATA.BASE_INFO.ID_ADDR", ""),
                OFFICE_ADDR_DATA_SOURCE: _.get(params, "BIZ_DATA.BASE_INFO.ID_ADDR_DATA_SOURCE", ""),
                CORP_ADDR: _.get(params, "BIZ_DATA.CONTACT_INFO.CORP_ADDR", ""),
                CORP_ADDR_DATA_SOURCE: _.get(params, "BIZ_DATA.CONTACT_INFO.CORP_ADDR_DATA_SOURCE", "")
              };

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], officeInfo);
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH2 + "[0]"], linkManInfo);

              _.set(params, SAVE_PATH2, [_Object$assign({}, _.get(params, SAVE_PATH2[0], {}), linkManInfo, { IS_SAME_AGENT: contactInfo.IS_SAME_AGENT })]);
              _.set(params, SAVE_PATH, _Object$assign({}, _.get(params, SAVE_PATH, {}), officeInfo));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  getLinkInfo: function getLinkInfo(_this) {
    return bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2], true);
  },

  pageActivated: function pageActivated(_this, groupId) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  "CHECK_LINKMAN_ID_TYPE": function CHECK_LINKMAN_ID_TYPE(_this, field, fieldData) {
    fieldData["LINKMAN_ID"] && (fieldData["LINKMAN_ID"].VALID_TYPE = _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    fieldData["LINKMAN_ID"].DEFAULT_VALUE = "";
  },
  "CHECK_LINKMAN_ID": function CHECK_LINKMAN_ID(_this, field, fieldData, moduleObj, index, isAuto) {
    if (field.DEFAULT_VALUE == "" || _this.userType != "2") {
      return;
    }
    field.DEFAULT_VALUE && _this.$blMethod.isDisabledLongTime(_this, fieldData.LINKMAN_ID_TYPE.DEFAULT_VALUE, field.DEFAULT_VALUE, fieldData.LINKMAN_EXP_DATE);
    fieldData.LINKMAN_SEX.DEFAULT_VALUE = utils.getSex(field.DEFAULT_VALUE);
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOther/bizOtherLinkInfoNode.js
// module id = 127
// module chunks = 2